export default "__VITE_ASSET__BzSpOvWS__"